import { composeModule } from '@opengov/compose-app';
import pkg from '../package.json';

var _composeModule = composeModule(pkg.name, pkg.version),
    composeStateMachine = _composeModule.composeStateMachine,
    composeEffects = _composeModule.composeEffects,
    composeMiddleware = _composeModule.composeMiddleware,
    composeSubscriber = _composeModule.composeSubscriber,
    exportModule = _composeModule.exportModule;

export { composeStateMachine, composeEffects, composeMiddleware, composeSubscriber, exportModule };